export * from './getDefaultLogger';

export { default as getDefaultLogger } from './getDefaultLogger';
